import React from "react";

export default function PageHeader({ eyebrow, title, description, actions }) {
  return (
    <div className="border-b border-border bg-white">
      <div className="px-8 py-6 flex items-end justify-between gap-6">
        <div>
          {eyebrow && (
            <div className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground mb-2">
              {eyebrow}
            </div>
          )}
          <h1 className="font-display text-3xl sm:text-4xl tracking-tight font-bold leading-none">
            {title}
          </h1>
          {description && (
            <p className="text-sm text-muted-foreground mt-2 max-w-2xl">{description}</p>
          )}
        </div>
        {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
      </div>
    </div>
  );
}
